export class Prospect {
  prosDocumenTYpe: string;
  prosDocumentNumber: string;
  prosApellidos: string;
  prosNombres: string;
  prosCelPhone: string;
  prosEmail: string;
  prosConsenmiento: number;
  prosDniVendedor: string;
  prosAgenciaVendedor: string;
}
